import { Component, ComponentRef, Directive, Injectable, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalService } from 'src/app/services/modal/modal.service';
import { FiltrePatientVitale, PatientService } from 'src/app/services/patient/patient.service';
import { FiltrePatient } from 'src/app/utils/interfaces/new/filtre-patient.interface';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { CardIcon } from 'src/app/utils/interfaces/old/card-icon-interface';
import { DateAdapter, NativeDateAdapter } from '@angular/material/core';
import { CreationPatient } from 'src/app/utils/interfaces/new/creation-patient.interface';
import { CabinetService } from 'src/app/services/office/cabinet.service';
import { LoginService } from 'src/app/services/login/login.service';
import { MatDatepicker } from '@angular/material/datepicker';
import * as moment from 'moment';
import { debounceTime } from 'rxjs/operators';
import { HeaderCommunicationService } from 'src/app/services/node/header-communication.service';
import { Header } from 'src/app/utils/interfaces/new/header.interface';
import { ResultatPatient } from 'src/app/utils/interfaces/new/resultat-patient.interface';
import { Subscription } from 'rxjs';
import { NotePatient } from 'src/app/utils/interfaces/new/note-patient.interface';
import { InfosPatientCarteVitale } from 'src/app/utils/interfaces/new/infos-patient-carte-vitale.interface';
import { CannotOpenSession, CannotReadVitale, CpxCard, MultipleVitaleCards, NoVitaleCard, VitaleCardRipped } from 'src/app/services/cpx-handle/cpx-handle.error';
import { CpxHandleServiceAbstract } from 'src/app/services/cpx-handle/cpx-handle-service-abstract';
import { Referentiel } from 'src/app/utils/interfaces/new/referentiel.interface';
import { ReferentielService } from 'src/app/services/referentiel/referentiel.service';
import { ReferentielEnum } from 'src/app/utils/enums/referentiel-enum';
import { Patients } from 'src/app/utils/interfaces/new/lecture-carte-vitale';
import { CombinatedDroits, DroitAcces } from 'src/app/utils/interfaces/new/combinateddroits.interface';
import { CreatePatientExistsFragment, FORCE_CREATE_PATIENT } from 'src/app/fragments/modal/create-patient-exists/create-patient-exists.fragment';
import { ErrorExistingPatient, isErrorExistingPatientInterface } from 'src/app/utils/interfaces/new/error-existing-patient.interface';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { Moment } from 'moment';
import { DroitsService } from 'src/app/services/droits/droits.service';
import { ListeDeTravailService } from 'src/app/services/liste-de-travail/liste-de-travail-patient.service';
import { ElementListeDeTravail } from 'src/app/utils/interfaces/new/ElementListeDeTravail';
import { NoIdentityFound, MultipleIdentitiesFound } from 'src/app/services/ins/ins.error';
import { Identity } from 'src/app/utils/interfaces/new/lecture-ins.interface';

enum RechercheTemplateState {
  Recherche = 'recherche',
  PatientsRecents = 'patients-recents',
  ListeDeTravail = 'liste-de-travail',
}

type LastSearchEntry = { key: string; value: string };

@Injectable()
class CustomDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
    return date.getFullYear().toString();
  }
}

@Directive({
  selector: '[dateFormat]',
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter }
  ]
})
export class YearDateFormat {
}

@Component({
  selector: 'app-recherche-patient',
  templateUrl: './recherche-patient.component.html',
  styleUrls: ['./recherche-patient.component.scss']
})
export class RecherchePatientComponent implements OnInit, OnDestroy {
  isAlreadyClick: boolean;

  chosenYearHandler(normalizedYear: Date, datepicker: MatDatepicker<Date>) {
    const ctrlValue = normalizedYear;
    this.searchForm.get('anneeNaissance').setValue(ctrlValue);
    datepicker.close();
  }

  public accountName = 'Docteur Renaud';

  public emptyIconVitale: CardIcon = {
    src: 'assets/icons/card.svg',
    fill:'var(--darkest-primary)',
    title: 'Récupérer informations depuis la carte vitale'
  };
  public emptyIconAdd: CardIcon = {
    src: 'assets/icons/user-plus.svg',
    stroke: 'var(--darkest-primary)',
    title: 'Nouveau patient'
  };


  public patientList: Paginated<any>;
  public filtre: Filtres = {
    perpage: 10,
    currentPage: 1
  };
  public filtrePatient: FiltrePatient;
  public isRowsClickable: boolean = true;

  public usersCabinet = [];

  public groupeList = [
    { id: '4741cbcf-40f5-4561-aaef-7420d83822b8', libelle: 'Sida' },
    { id: '5d4eebc4-7271-41b5-b3b8-764e15ded45e', libelle: 'Cancer' },
    { id: '902e1f0a-a6ce-45cf-a58a-ae3868ddcf4f', libelle: 'Diabète' },
  ];

  public tagList: Referentiel[];

  public patientVitaleColumnTable = [
    { title: 'Nom', data: 's_name' },
    { title: 'Nom de naissance', data: 's_birthname' },
    { title: 'Prénom', data: 's_given' },
    { title: 'Date de naissance', data: 's_birthday' },
    { title: 'NIR', data: 's_nir' },
    { title: 'INSC', data: 's_insC' },
  ];

  public patientColumnTable = [
    { title: '', data: 'tag', isCellColor: true },
    // { title: 'Patient', data: 'nomPrenomDateNaissance' },
    { title: 'Nom de naissance', data: 'nomNaissance' },
    { title: 'Nom utilisé', data: 'nomUsage' },
    { title: '1er prénom de naissance', data: 'prenomNaissance' },
    { title: 'Prénom utilisé', data: 'prenomUsage' },
    { title: 'Date de naissance', data: 'ddn' },
    { title: 'Sexe', data: 'sexe' },
    { title: 'Lieu de naissance', data: 'lieuNaissance' },
    { title: 'Statut de l\'identité', data: 'statutIdentiteLabel' },
    { title: 'Suivi par', data: 'suiviPar' },
    { title: 'ROSP', data: 'isRospLabel' },
    { title: 'Note', data: null }
  ];

  public listeDeTravailColumnTable = [
    { title: '', data: 'tag', isCellColor: true },
    { title: 'Patient', data: 'nomPrenomDateNaissance' },
    { title: 'Nom de naissance', data: 'nomNaissance' },
    { title: 'Nom utilisé', data: 'nomUsage' },
    { title: '1er prénom de naissance', data: 'prenomNaissance' },
    { title: 'Prénom utilisé', data: 'prenomUsage' },
    { title: 'Date de naissance', data: 'ddn' },
    { title: 'Sexe', data: 'sexe' },
    { title: 'Suivi par', data: 'suiviPar' },
    { title: 'Supprimer', data: null }
  ];

  isNameDisabled: boolean = false;
  public useSearshOnly = false;
  private _navigateFromEventSearch = false;
  private _navigateFromMultiprofessionnalMeetingEdit = false;
  public _navigateToPatientSearchAddCorrespondant: boolean = false;
  private _navigateToMultiprofessionnalProtocolEditSearch: boolean = false;
  private _navigateToMSS = false;

  public isExpendable = false;
  public displayState: RechercheTemplateState =  RechercheTemplateState.Recherche;
  public displayStateTemplate = RechercheTemplateState;

  public maxDate = moment().format("YYYY-MM-DD");
  public minDate = moment((moment().year() - 150) + "-" + moment().month() + "-" + moment().day()).format("YYYY-MM-DD");

  public searchForm: FormGroup;
  public nirSearchForm: FormGroup;
  private lastSearch: string = '';
  public isTableLoading: boolean = false;

  public closeListener: Subscription;
  public formSubscription: Subscription;
  public insRight: DroitAcces;

  constructor(
    private _router: Router,
    private _formBuilder: FormBuilder,
    private _patientService: PatientService,
    private _modalService: ModalService,
    private _view: ViewContainerRef,
    private _cabinet: CabinetService,
    private _login: LoginService,
    private _send: HeaderCommunicationService,
    private _activatedRoute: ActivatedRoute,
    private _cpxHandleSrv: CpxHandleServiceAbstract,
    private _ref: ReferentielService,
    private _strUtilsSrv: StringUtilsService,
    private _droitService: DroitsService,
    private _listeDeTravailSrv: ListeDeTravailService
  ) {
    if (this._activatedRoute.snapshot.queryParamMap.get('navigateToEventSearch')) {
      const head: Header = {
        isBack: true,
        title: "Recherche patient agenda",
        backPage: "agenda/search"
      };
      this._send.announceHeader(head);
      this._navigateFromEventSearch = true;
      this.useSearshOnly = true;
    } else if (this._activatedRoute.snapshot.queryParamMap.get('navigateToMultiprofessionnalMeetingEditSearch')) {
      const head: Header = {
        isBack: true,
        title: 'Recherche patient réunion',
        backPage: 'user/reunions/edit'
      };
      this._send.announceHeader(head);
      this._navigateFromMultiprofessionnalMeetingEdit = true;
      this.useSearshOnly = true;
    } else if (this._activatedRoute.snapshot.queryParamMap.get('navigateToPatientSearchAddCorrespondant')) {
      const head: Header = {
        isBack: true,
        title: "Recherche patient correspondant",
        backPage: "user/correspondant"
      };
      this._send.announceHeader(head);
      this._navigateToPatientSearchAddCorrespondant = true;
      this.useSearshOnly = true;
    } else if (this._activatedRoute.snapshot.queryParamMap.get('navigateToMultiprofessionnalProtocolEditSearch')) {
      const head: Header = {
        isBack: true,
        title: "Recherche patient protocole",
        backPage: "user/protocoles/edit"
      };
      this._send.announceHeader(head);
      this._navigateToMultiprofessionnalProtocolEditSearch = true;
      this.useSearshOnly = true;
    } else if (this._activatedRoute.snapshot.queryParamMap.get('navigateToMSS')) {
      const head: Header = {
        isBack: true,
        title: "Recherche pièce jointe",
        backPage: "user/messagerie"
      };
      this._send.announceHeader(head);
      this._navigateToMSS = true;
      this.useSearshOnly = true;
    } else {
      const head: Header = {
        isBack: true,
        title: "Recherche patient",
        backPage: "home"
      };
      this._send.announceHeader(head);
    }

    this._droitService.isBdg = false;
  }

  ngOnDestroy() {
    if (this.formSubscription) {
      this.formSubscription.unsubscribe();
    }
  }

  async ngOnInit(): Promise<void> {
    const loadingModal = this._modalService.openLoading(this._view);
    if (this._activatedRoute.snapshot.queryParamMap.get('navigateToEventSearch')) {
      this.patientColumnTable = [
        { title: 'Patient', data: 'nomPrenom' },
        { title: 'Date de nais.', data: 'dateNaissance' }
      ];
    }
    if (this._activatedRoute.snapshot.queryParamMap.get('navigateToMultiprofessionnalMeetingEditSearch')) {
      this.patientColumnTable = [
        { title: 'Patient', data: 'nomPrenomDateNaissance' }
      ];
    }
    if (this._activatedRoute.snapshot.queryParamMap.get('navigateToPatientSearchAddCorrespondant')) {
      this.patientColumnTable = [
        { title: 'Patient', data: 'nomPrenomDateNaissance' },
        { title: 'Nom d\'usage', data: 'nomUsage' },
      ];
    }
    if (this._activatedRoute.snapshot.queryParamMap.get('navigateToMultiprofessionnalProtocolEditSearch')) {
      this.patientColumnTable = [
        { title: 'Patient', data: 'nomPrenomDateNaissance' }
      ];
    }
    const currentProfil = this._login.getCurrentProfil();
    const destinatairesCabinet = await this._cabinet.findCurrentCabinetDestinataire();
    const combinatedRights = await this._droitService.findMyCombinedDroits();
    this.insRight = combinatedRights.droits.find(x => x.nom === "Ins");
    this.tagList = await this._ref.findRefListTable(ReferentielEnum.tag);

    for (let destinataire of destinatairesCabinet) {
      if (!destinataire.disabled) {
        this.usersCabinet.push({ id: destinataire.id, libelle: destinataire.nom.toLocaleUpperCase() + ' ' + this._strUtilsSrv.uppercaseFirstCharString(destinataire.prenom) });
      }
    }

    //Derniere recherche
    const raw = localStorage.getItem('lastSearch');
    if (!raw) {
      this.lastSearch = '';
    } else {
      try {
        const arr = JSON.parse(raw) as unknown;
        if (Array.isArray(arr)) {
          const hit = (arr as LastSearchEntry[])
            .find(e => e && String(e.key) === String(currentProfil.id));
          this.lastSearch = hit?.value ?? '';
        } else {
          // JSON au mauvais format
          this.lastSearch = '';
        }
      } catch {
        // JSON corrompu
        this.lastSearch = '';
      }
    }

    this.searchForm = this._formBuilder.group({
      nom: [this.lastSearch],
      prenom: [''],
      anneeNaissance: [],
      lieuNaissance: [''],
      numeroDossier: [''],
      dateNaissance: [''],
      dossierArchive: [false],
      brisDeGlace: [false],
      recherche: [''],
      suiviPar: [''],
      groupePatient: [''],
      nomSpe: [false],
      prenomSpe: [false],
      nomUsageSpe: [false],
      nomNaisSpe: [false],
      prenomNaisSpe: [false],
      prenomUsageSpe: [false],
      tagPatient: [''],
      dateDebutSuivi: [''],
      dateFinSuivi: [''],
      libSuivi: [''],
      numDosSpe: [false],
      phonetiqueNom: [false],
    });

    this.nirSearchForm = this._formBuilder.group({
      nir: ['', [Validators.required, Validators.minLength(13), Validators.maxLength(13), Validators.pattern(PatientService.REXEG_NIR_13)]],
      nirKey: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(2)]],
    });

    this.formSubscription = this.searchForm.valueChanges.pipe(debounceTime(500)).subscribe(async val => {
      this._droitService.isBdg = !!val.brisDeGlace;
      this.onChanges(val);
    });
    this._modalService.close(loadingModal);
  }

  private setLastSearch(value: string) {
    const currentProfil = this._login.getCurrentProfil();
    const userId = currentProfil.id;
    let arr: LastSearchEntry[] = [];
    try {
      const raw = localStorage.getItem('lastSearch');
      const parsed = raw ? JSON.parse(raw) : [];
      if (Array.isArray(parsed)) arr = parsed as LastSearchEntry[];
    } catch { /* ignore */ }

    const uid = String(userId);
    const i = arr.findIndex(e => String(e.key) === uid);
    if (i >= 0) arr[i].value = value;
    else arr.unshift({ key: uid as any, value });

    // Garde-fou
    const MAX = 20;
    if (arr.length > MAX) arr.length = MAX;

    localStorage.setItem('lastSearch', JSON.stringify(arr));
  }

  public async getPatientsFiltres(): Promise<void> {
    this.isTableLoading = true;
    if (this.filtrePatient) {
      if (this.filtrePatient && this.filtrePatient.openListId && !this.filtrePatient.nom) {
        this.filtrePatient.nom = '';
      }

      this.patientList = await this._patientService.patientsSearchFilters(this.filtrePatient, this.filtre) as Paginated<ResultatPatient>;
      if (this.patientList && this.patientList.objects && this.patientList.objects.length > 0) {
        const patients = this.patientList.objects as ResultatPatient[];
        this.patientList.objects = [];
        for (let patient of patients) {
          Object.defineProperty(patient, 'active2', { value: patient.isNoteActive ? 'var(--primary)' : 'var(--darkest-primary)', writable: true })
          const libTag = this.tagList?.find(x => x.id === patient.tag) ? this.tagList.find(x => x.id === patient.tag).libelle : undefined;
          const respPatient = this.usersCabinet?.find(x => x.id === patient.suiviPar) ? this.usersCabinet.find(x => x.id === patient.suiviPar).libelle : undefined;
          if (libTag) {
            patient.tag = libTag;
          } else {
            patient.tag = '';
          }
          if (respPatient) {
            patient.suiviPar = respPatient;
          } else {
            patient.suiviPar = '';
          }

          (patient as any).isRospLabel = patient.isRosp ? 'Oui' : 'Non';

          (patient as any).ddn = patient.dateNaissance;
          (patient as any).statutIdentiteLabel = patient.statutIdentite ? patient.statutIdentite.libelleStatus : '';

          this.patientList.objects.push(patient);

          /**
           * pour afficher les patients récemment consultés avec le dernier en premier dans la liste:
           * on prend le tableau des ids des patients récemment consultés
           * et on trie this.patientList.objects en fonction de cet ordre et on reverse le tableau pour inverser l'ordre ( car on veut le dernier patient en premier dans la liste)
           */

          const openListId = this.filtrePatient.openListId;
          if (openListId) {
            const orderedPatients = openListId
              .map(id => {
                const patient = this.patientList.objects.find(p => p.id === id);
                if (!patient) {
                  console.warn(`Patient introuvable pour l'id: ${id}`);
                }
                return patient;
              })
              .filter((p): p is ResultatPatient => !!p)

            this.patientList.objects = orderedPatients.reverse();
          }

        }
      }
    } else {
      this.patientList.objects = [];
    }
    this.isTableLoading = false;
  }

  public async onSort(event: any): Promise<void> {
    this.filtre.currentPage = 1;
    this.filtre.sortOrder = event.sortOrder;
    this.filtre.sortBy = event.sortBy;
    this.getPatientsFiltres();
  }

  public async onChangePage(value: any): Promise<void> {
    this.filtre.currentPage = value;
    this.getPatientsFiltres();
  }

  public onChanges(val: any): void {
    if (this.filtrePatient && !this.filtrePatient.openListId) {
      this.filtrePatient = undefined;
    }
    this.patientList = undefined;
    /**
     * Les conditions suivantes permettent de déterminer si la recherche peut être lancée.
     * Les conditions pour lancer une recherche sont les suivantes :
     * - les champs nom ET prenom sont tout les deux vides
     * - le champ nom OU le champ prénom a 3 caractères ou plus
     */
    let canSearch = false;

    if (this.filtrePatient && this.filtrePatient.openListId && this.filtrePatient.openListId.length > 0) {
      canSearch = true;
    } else {
      if (this.isExpendable) {

        if (val.suiviPar || val.groupePatient || val.tagPatient || val.dateDebutSuivi || val.dateFinSuivi) {
          canSearch = true;
        }
        if (!canSearch && (val.recherche && val.recherche.length >= 3)) {
          canSearch = true;
        }
        if (!canSearch && (val.libSuivi && val.libSuivi.length >= 3)) {
          canSearch = true;
        }

      } else {

        if ((val.nom && val.nom.length >= 3) || (val.prenom && val.prenom.length >= 3)) {
          canSearch = true;
          this.setLastSearch(val.nom);
        }
        if (!canSearch && (!val.nom || val.nom.length === 0) && (!val.prenom || val.prenom.length === 0) && ((val.lieuNaissance && val.lieuNaissance.length > 0) || (val.anneeNaissance && val.anneeNaissance.toString().length === 4) || (val.numeroDossier && val.numeroDossier.length > 0))) {
          canSearch = true;
        }
        if ((val.lieuNaissance && val.lieuNaissance.length > 0) || (val.anneeNaissance && val.anneeNaissance.toString().length === 4) || (val.numeroDossier && val.numeroDossier.length > 0)) {
          canSearch = true;
        }
        if (val.dateNaissance && (val.dateNaissance as Moment).isValid() && (val.dateNaissance as Moment).format("YYYY-MM-DD").length > 0) {
          canSearch = true;
        }
      }
    }

    if (!canSearch) {
      return;
    }
    /**
     * Fin de la vérification de possibilité de lancer la recherche
     */

    if ((val.recherche && val.recherche !== '') && !val.nomSpe && !val.prenomSpe && !val.nomUsageSpe && !val.nomNaisSpe && !val.numDosSpe
      && !val.prenomNaisSpe && !val.prenomUsageSpe) {
      this.filtrePatient = {
        nom: val.nom ? val.nom : '',
        prenom: val.prenom ? val.prenom : '',
        anneeNaissance: val.anneeNaissance ? val.anneeNaissance : '',
        dateNaissance: val.dateNaissance && (val.dateNaissance as Moment).isValid() ? (val.dateNaissance as Moment).format("YYYY-MM-DD") : '',
        lieuNaissance: val.lieuNaissance ? val.lieuNaissance : '',
        numeroDossier: val.numeroDossier ? val.numeroDossier : '',
        rechercheSpe: val.recherche ? val.recherche : '',
        idResponsableDossier: val.suiviPar ? val.suiviPar : '',
        idGroupe: val.groupePatient ? val.groupePatient : '',
        onNom: true,
        onPrenom: true,
        onNomUsage: true,
        onNomNaissance: true,
        onPrenomUsage: true,
        onPrenomNaissance: true,
        idTag: val.tagPatient ? val.tagPatient : '',
        dateDebutSuivi: val.dateDebutSuivi ? val.dateDebutSuivi : '',
        dateFinSuivi: val.dateFinSuivi ? val.dateFinSuivi : '',
        libelleTypeSuivi: val.libSuivi ? val.libSuivi : '',
        onNumeroSecSoc: true,
        onNumeroDossier: true,
        isPhonetique: val.phonetiqueNom ? val.phonetiqueNom : false,
        getArchive: val.dossierArchive ? val.dossierArchive : false,
        openListId: this.filtrePatient ? this.filtrePatient.openListId : undefined,
      }
    } else {
      this.filtrePatient = {
        nom: val.nom ? val.nom : '',
        prenom: val.prenom ? val.prenom : '',
        anneeNaissance: val.anneeNaissance ? val.anneeNaissance : '',
        dateNaissance: val.dateNaissance && (val.dateNaissance as Moment).isValid() ? (val.dateNaissance as Moment).format("YYYY-MM-DD") : '',
        lieuNaissance: val.lieuNaissance ? val.lieuNaissance : '',
        numeroDossier: val.numeroDossier ? val.numeroDossier : '',
        rechercheSpe: val.recherche ? val.recherche : '',
        idResponsableDossier: val.suiviPar ? val.suiviPar : '',
        idGroupe: val.groupePatient ? val.groupePatient : '',
        onPrenom: val.prenomSpe ? val.prenomSpe : false,
        onPrenomUsage: val.prenomUsageSpe ? val.prenomUsageSpe : false,
        onPrenomNaissance: val.prenomNaisSpe ? val.prenomNaisSpe : false,
        onNom: val.nomSpe ? val.nomSpe : false,
        onNomUsage: val.nomUsageSpe ? val.nomUsageSpe : false,
        onNomNaissance: val.nomNaisSpe ? val.nomNaisSpe : false,
        idTag: val.tagPatient ? val.tagPatient : '',
        dateDebutSuivi: val.dateDebutSuivi ? val.dateDebutSuivi : '',
        dateFinSuivi: val.dateFinSuivi ? val.dateFinSuivi : '',
        libelleTypeSuivi: val.libSuivi ? val.libSuivi : '',
        onNumeroDossier: val.numDosSpe ? val.numDosSpe : false,
        isPhonetique: val.phonetiqueNom ? val.phonetiqueNom : false,
        getArchive: val.dossierArchive ? val.dossierArchive : false,
        openListId: this.filtrePatient ? this.filtrePatient.openListId : undefined,
      }
    }
    this.filtre.currentPage = 1;
    this.getPatientsFiltres();

  }

  public routeTo(routeInfo: string): void {
    this._router.navigateByUrl("/user/" + routeInfo);
  }

  public onSubmit() {

  }

  public async searchWithNir(): Promise<void> {
    try {
      if (this.nirSearchForm) {
        // On valide l'INS en calculant la clé (source : https://www.republicain-lorrain.fr/culture-loisirs/2021/01/21/securite-sociale-cle-de-controle-a-deux-chiffres#:~:text=Une%20cl%C3%A9%20de%20contr%C3%B4le%20%C3%A0,d'une%20division%20euclidienne).)
        const ctrlNumb = 97;
        const nir = this.nirSearchForm.get('nir').value;
        const nirKey = this.nirSearchForm.get('nirKey').value;

        if (Number.isNaN(Number(nir))) {
          this._modalService.openAlert(
            this._view, 'Erreur de saisie', 'L\'INS ne peut contenir que des chiffres.'
          );
          return;
        }

        if (Number.isNaN(Number(nirKey))) {
          this._modalService.openAlert(
            this._view, 'Erreur de saisie', 'La clé d\'INS ne peut contenir que des chiffres.'
          );
          return;
        }

        const calcResult = ctrlNumb - (Number(nir) % ctrlNumb);
        if (calcResult !== Number(nirKey)) {
          this._modalService.openAlert(
            this._view, 'INS non valide', 'L\'INS et la clé ne sont pas cohérents.\nUne erreur de saisie peut en être la cause.'
          );
          return;
        }

        this.filtrePatient = { nir, nirKey, getArchive: false };
        const temp = await this._patientService.patientsSearchFilters(this.filtrePatient, this.filtre) as Paginated<ResultatPatient>;
        temp.objects.map(p => {
          (p as any).ddn = p.dateNaissance;
        });
        this.patientList = temp;
        this.filtrePatient = undefined;
      }
    } catch (e) {
      let msg = 'Une erreur est survenue lors de la recherche de ce NIR.';
      if (e.message && e.message !== '') {
        msg = e.message;
      }
      this._modalService.openAlert(this._view, 'Erreur', msg);
    }
  }

  public activateButtonPatient() {
    this.displayState = RechercheTemplateState.Recherche;
    if (this.filtrePatient && this.filtrePatient.openListId) {
      this.filtrePatient.openListId = undefined;
    }
    this.onChanges(this.searchForm.value);
  }

  public activateButtonRecent() {
    this.displayState = RechercheTemplateState.PatientsRecents;
    const localItem = localStorage.getItem('openPatients');
    if (localItem) {
      if (this.filtrePatient) {
        this.filtrePatient.openListId = JSON.parse(localItem) as string[];
      } else {
        this.filtrePatient = {
          openListId: JSON.parse(localItem) as string[],
          getArchive: false
        };
      }
    } else {
      this._modalService.openAlert(this._view, "Aucun patient récent", "Aucun dossier patient n'a été consulté depuis votre connexion.");
    }
    this.onChanges(this.searchForm.value);
  }

  public async activateButtonListeDeTravail(): Promise<void> {
    this.isTableLoading = true;
    this.displayState = RechercheTemplateState.ListeDeTravail;
    await this._initListeDeTravail();
    this.isTableLoading = false;
  }

  private async _initListeDeTravail(): Promise<void> {
    if (this.filtrePatient && this.filtrePatient.openListId) {
      this.filtrePatient.openListId = undefined;
    }

    this._listeDeTravail = await this._listeDeTravailSrv.getListe();
    const liste = this._listeDeTravail.filter(e => e.patient).map(p => p.patient.id);
    if (liste && liste.length > 0) {
      if (this.filtrePatient) {
        this.filtrePatient.openListId = liste;
      } else {
        this.filtrePatient = {
          openListId: liste,
          getArchive: false
        };
      }
    } else {
      this._modalService.openAlert(this._view, 'Aucun patient', 'Aucun patient dans votre liste de travail');
    }
    this.onChanges(this.searchForm.value);
  }

  private _listeDeTravail: Array<ElementListeDeTravail> = [];
  public async deleteElemFromListeDeTravail(evt): Promise<void> {
    const elem = this._listeDeTravail.find(e => e.patient && e.patient.id === evt.id);
    if (elem) {
      await this._listeDeTravailSrv.deleteElemFromListe(elem.id);
      await this._initListeDeTravail();
    }
  }

  public expend() {
    this.isExpendable = !this.isExpendable
    this.searchForm.reset();
  }

  public async addPatient(infosPatient?: InfosPatientCarteVitale, previousPatient?: CreationPatient): Promise<void> {
    const tmpDocsIdentiteHaut = await this._ref.findRefListTable(ReferentielEnum.identiteDocsHaut);
    const tmpDocsIdentiteBas = await this._ref.findRefListTable(ReferentielEnum.identiteDocsBas);
    const tmpAttributIdentiteOk = await this._ref.findRefListTableHypermed(ReferentielEnum.identiteAttributOk);
    const tmpAttributIdentiteKo = await this._ref.findRefListTableHypermed(ReferentielEnum.identiteAttributKo);
    const docsIdentiteList = [].concat(tmpDocsIdentiteHaut, tmpDocsIdentiteBas);
    const attributsIdentiteList = [].concat(tmpAttributIdentiteOk, tmpAttributIdentiteKo);

    const modal = this._modalService.openModalAddPatient("Nouveau patient", this._view, { attributsIdentiteList, docsIdentiteList }, infosPatient);

    if (previousPatient) {
      setTimeout(() => {
        modal.instance.initFormFromOustide(previousPatient);
      }, 100);
    }

    const sub = modal.instance.closeEmitter.subscribe(
      async response => {
        if (response) {
          if (response.nav && response.nav === 'NAVIGATE_TO_PATIENT_DETAILS' && response.patientId && response.patientId !== '') {
            //this._router.navigateByUrl(`patient/${response.patientId}`);
            this.openFichePatient({id: response.patientId});
            modal.destroy();
          } else {
            if (infosPatient && infosPatient.ins && infosPatient.ins !== ''
            && response.object && response.object.ins && response.object.ins !== '') {
              response.object.ins = infosPatient.ins;
            }
            response.addPatientFragment = modal;
            await this.addPatientCloseListener(response);
          }
          sub.unsubscribe();
        }
      }
    );
  }

  async addPatientCloseListener(response: any, forceCreatePatient = false) {
    try {
      const createPatient: CreationPatient = response.object;
      const idPatient = await this._patientService.createPatient(createPatient, forceCreatePatient);
      if (response.addPatientFragment.instance.couverturePatient) {
        await this._patientService.updatePatientCouverture(idPatient, response.addPatientFragment.instance.couverturePatient);
      }
      this._modalService.close(response.loadingModal);
      this._modalService.close(response.addPatientFragment);
      this._router.navigateByUrl(`user/patient/${idPatient}`);
    } catch (e) {
      if (e && e.code && e.code === 3) {
        this._modalService.close(response.addPatientFragment);
        const modal = this._modalService.openModal<CreatePatientExistsFragment>(
          this._view,
          CreatePatientExistsFragment
        ) as ComponentRef<CreatePatientExistsFragment>;
        modal.instance.patients = e.patients;

        const sub = modal.instance.closeEmitter.subscribe(async res => {
          if (res) {
            if (res === FORCE_CREATE_PATIENT) {
              modal.destroy();
              await this.addPatientCloseListener(response, true);
            } else if (isErrorExistingPatientInterface(res)) {
              const patient = res as ErrorExistingPatient;
              this._router.navigateByUrl(`user/patient/${patient.id}`);
              modal.destroy();
            }
          } else {
            modal.destroy();
            this.addPatient(undefined, response.object as CreationPatient);
          }
          sub.unsubscribe();
        });
      } else {
        this._modalService.close(response.loadingModal);
        response.addPatientFragment.instance.isError = true;
        response.addPatientFragment.instance.errorMessage = e.message;
        response.addPatientFragment.instance.isSubmitDisabled = false;
        setTimeout(() => {
          if (response && response.addEditFragment && response.addEditFragment.instance) {
            response.addEditFragment.instance.isError = false;
          }
        }, 5000);
      }
    }
  }

  async openPatient(event: any) {
    if (this.isAlreadyClick) {
      return;
    }
    this.isAlreadyClick = true;
    // utilisation de ce endpoint pour verif droit acces TODO à faire autrement quand endPoint haveAcces ok
    const note = await this._patientService.findOnePatientNote(event.id);
    if(note !== undefined){
      if (this._navigateFromEventSearch) {
        this._router.navigateByUrl(this._router.createUrlTree(['/user/agenda/search'], { queryParams: { patientId: event.id } }));
      } else if (this._navigateFromMultiprofessionnalMeetingEdit) {
        const meetingId = this._activatedRoute.snapshot.queryParamMap.get('meetingId');
        const path = meetingId ? `user/reunions/edit/${meetingId}` : 'user/reunions/edit';
        this._router.navigateByUrl(
          this._router.createUrlTree(
            [path], {
            queryParams: {
              doAddPatient: true,
              patientId: event.id
            }
          }
          )
        );
      } else if (this._navigateToPatientSearchAddCorrespondant) {
        const correspondantId = this._activatedRoute.snapshot.queryParamMap.get('correspondantId');
        const patientRepertoire = await this._patientService.findOnePatientRepertoire(event.id);
        patientRepertoire.correspondants.push({
          idCorrespondant: correspondantId,
          idPatient: event.id,
          disabled: false,
        });
        await this._patientService.updatePatientRepertoire(event.id, patientRepertoire);
        this._router.navigateByUrl('user/correspondant');
      } else if (this._navigateToMultiprofessionnalProtocolEditSearch) {
        const protocolId = this._activatedRoute.snapshot.queryParamMap.get('protocolId');
        const path = protocolId ? `user/protocoles/edit/${protocolId}` : 'user/protocoles/edit';
        this._router.navigateByUrl(
          this._router.createUrlTree(
            [path], {
            queryParams: {
              doAddPatient: true,
              patientId: event.id
            }
          }
          )
        );
      } else if (this._navigateToMSS) {
        localStorage.setItem('MSSLinkAttachmentResultPatient', JSON.stringify({
          patientId: event.id,
          patientLabel: event.nomPrenomDateNaissance
        }));
        this._router.navigateByUrl(
          this._router.createUrlTree(['user/messagerie'])
        );
      } else {
        this.openFichePatient(event);
      }
    }
    this.isAlreadyClick = false;
  }

  private openFichePatient(event: any) {
    this._router.navigateByUrl(`/user/patient/${event.id}`);
  }

  addCorrespondantPatient(event: any) {

  }

  async openNotePatient(event: any) {
    const note = await this._patientService.findOnePatientNote(event.id);
    if (note !== undefined) {
      this._modalService.openModalAddEdit(event.nomPrenom, this._view, {
        inputs: [{
          id: 'note',
          label: 'Note',
          placeholder: 'Note attachée au patient',
          type: 'textarea',
          variable: 'noteGlobale'
        }]
      }, true, note);
      this.closeListener = this._modalService.closeEmitter.subscribe({
        next: async response => {
          if (response) {
            try {
              if (response.object) {
                const note: NotePatient = {
                  id: event.id,
                  noteGlobale: response.object.noteGlobale
                }
                await this._patientService.updatePatientNote(event.id, note);

                await this.getPatientsFiltres();
              }
              this._modalService.close(response.loadingModal);
              this._modalService.close(response.addEditFragment);
              this.closeListener.unsubscribe();
            } catch (e) {
              this._modalService.close(response.loadingModal);
              response.addEditFragment.instance.isError = true;
              response.addEditFragment.instance.errorMessage = 'Impossible d\'ajouter la note';
              setTimeout(() => {
                response.addEditFragment.instance.isError = false;
              }, 5000);
              this.closeListener.unsubscribe();
            }
          } else {
            this.closeListener.unsubscribe();
          }
        },
        complete: () => {
          this.closeListener.unsubscribe();
        },
      });
    }
  }

  async lectureCarteVitale() {
    const loadingModal = this._modalService.openLoading(this._view);

    try {
      const listPatientsCarte = await this._cpxHandleSrv.lectureVitale(this._view);
      this._modalService.close(loadingModal);
      const infosPatientCarte = this._mapInfosPatientCarteVitale(listPatientsCarte);
      if (infosPatientCarte.length === 1) {
        if (this.insRight.acces > 0) {
          this._getInsFromVitale(infosPatientCarte[0]);
        } else {
          const alertModal = this._modalService.openAlert(this._view, "Droits restreints", "Vous n'avez pas les droits requis pour accéder à l'INS du patient.");
        }
      } else {
        this._openModalPatientCarteVitale(infosPatientCarte);
      }
    }
    catch (e) {
      if (e instanceof CannotOpenSession) {
        this._modalService.openAlert(this._view, 'Erreur', 'Impossible de se connecter au lecteur de carte.');
      } else if (e instanceof NoVitaleCard) {
        this._modalService.openAlert(this._view, 'Erreur', 'Pas de carte vitale insérée.');
      } else if (e instanceof CpxCard) {
        this._modalService.openAlert(this._view, 'Erreur', 'Vous avez inséré une carte cpx.');
      } else if (e instanceof MultipleVitaleCards) {
        const slotNames = e.message.split(',');
        const propositions: Array<any> = [];
        for (let slotName of slotNames) {
          propositions.push({ label: slotName, value: slotName });
        }
        const modal = this._modalService.openModalMultipleChoice(this._view, 'Plusieurs cartes vitale insérées', 'Plusieurs cartes vitales ont été insérées.', 'Choisissez la carte à lire :', propositions);
        const modalSub = modal.instance.closeEmitter.subscribe(async (choice: string | null) => {
          const loadingModal = this._modalService.openLoading(this._view);
          const listPatientsCarte = await this._cpxHandleSrv.lectureVitale(this._view, choice);
          this._modalService.close(loadingModal);
          const infosPatientCarte = this._mapInfosPatientCarteVitale(listPatientsCarte);
          if (infosPatientCarte.length === 1) {
            this._getInsFromVitale(infosPatientCarte[0]);
          } else {
            this._openModalPatientCarteVitale(infosPatientCarte);
          }
          modalSub.unsubscribe();
        });
      } else if (e instanceof CannotReadVitale) {
        this._modalService.openAlert(this._view, 'Erreur', 'Impossible de lire la carte vitale.');
      } else if (e instanceof VitaleCardRipped) {
        this._modalService.openAlert(this._view, 'Erreur', 'Carte vitale arrachée.');
      }

      this._modalService.close(loadingModal);
      throw (e);
    }
  }

  private _mapInfosPatientCarteVitale(listPatientsCarte: any) {
    const infosPatientCarte: any[] = [];
    for (let [index, patient] of listPatientsCarte.Patients.entries()) {
      let birthday = '';
      let moonBirthday: string | undefined;
      // detection lunaire
      if (patient.s_birthday) {
        const parsed = patient.s_birthday ? this.parseBirthday(patient.s_birthday) : undefined;
        if (parsed?.isLunar) {
          moonBirthday = parsed.yyyymmdd;
        }
      }

      if (patient.s_birthday && moment(patient.s_birthday, 'DDMMYYYY').isValid()) {
        birthday = moment(patient.s_birthday, 'DDMMYYYY').format('DD/MM/YYYY');
      } else if (patient.s_birthdayYYYYMMDD && moment(patient.s_birthdayYYYYMMDD, 'YYYYMMDD').isValid()) {
        birthday = moment(patient.s_birthdayYYYYMMDD, 'YYYYMMDD').format('DD/MM/YYYY');
      } else if (patient.s_birthdayYYMMDD && moment(patient.s_birthdayYYMMDD, 'YYMMDD').isValid()) {
        birthday = moment(patient.s_birthdayYYMMDD, 'YYMMDD').format('DD/MM/YYYY');
      }

      infosPatientCarte.push({
        id: index,
        i_birthRank: patient.i_birthRank,
        i_quality: patient.i_quality,
        s_birthday: birthday,
        s_birthname: patient.s_birthname,
        s_certifiedNir: patient.s_certifiedNir ? patient.s_certifiedNir : undefined,
        s_given: patient.s_given,
        s_insC: patient.s_insC ? patient.s_insC : undefined,
        s_name: patient.s_name,
        s_nir: patient.s_nir ? patient.s_nir : undefined,
        s_moonbirthday: moonBirthday ? moonBirthday : undefined,
      });
    }
    return infosPatientCarte;
  }

  private async _getInsFromVitale(res: Patients): Promise<void> {

    const loading = this._modalService.openLoading(this._view);
    try {
    } catch (e) {
      let msg: string | undefined = undefined;
      let contextMsg = 'Une erreur est survenue lors de la récupération de l\'INS du patient';
      if (e.message && e.message !== '') {
        contextMsg = e.message;
      }
      if (e.s_status && (e.s_status === 'ERROR' || e.s_status === 'API_ERROR')) {
        contextMsg = e.s_apiErrorDescription ? e.s_apiErrorDescription : contextMsg;
        if (e.s_apiErrorTlsiErrorDetailCode && e.s_apiErrorTypeDescription && e.s_apiErrorTlsiErrorDetailError) {
          msg = `Code d'erreur : ${e.s_apiErrorTlsiErrorDetailCode}`;
          msg += `\nType de l'erreur : ${e.s_apiErrorTypeDescription}`;
          msg += `\nContexte de l'erreur : ${e.s_apiErrorContext}`;
          msg += `\nDétails de l'erreur : ${e.s_apiErrorTlsiErrorDetailError}`;
        } else {
          msg = e.s_apiErrorTlsiErrorDetailError ? e.s_apiErrorTlsiErrorDetailError : msg;
        }

        if (e.s_requestFrameInBase64) {
          console.error('Message d\'erreur pour le support (request) : ', e.s_requestFrameInBase64);
        }
        if (e.s_answerFrameInBase64) {
          console.error('Message d\'erreur pour le support (response) : ', e.s_answerFrameInBase64);
        }
      }

      if (e instanceof NoIdentityFound) {
        msg = 'Aucune identité trouvée.';
      } else if (e instanceof MultipleIdentitiesFound) {
        msg = 'Plusieurs identités trouvées, veuillez préciser votre recherche.';
      }

      this._modalService.openAlert(this._view, 'Erreur', contextMsg, undefined, msg);
      throw e;
    } finally {
      loading.destroy();
    }

    const filtreSearchPatient: FiltrePatient = {
      // Ajout de la recherche par nom de naissance ou nom d'usage
      nom: res.s_birthname?.trim() || res.s_name?.trim() || undefined,
      prenom: res.s_given && res.s_given !== '' ? res.s_given.trim() : undefined,
      dateNaissance: res.s_birthday && res.s_birthday !== '' ? moment(res.s_birthday, 'DD/MM/YYYY').format('YYYY-MM-DD') : undefined,
      //insc: res.s_insC ? res.s_insC : undefined,
      nir: res.s_nir ? res.s_nir.trim().split(/\s+/)[0] : undefined,//ajout recherche par nir
      nirKey: res.s_nir ? res.s_nir.trim().split(/\s+/)[1] : undefined,
      getArchive: true,
      allArchivedTypes: true
    };

    const PatientVitale: FiltrePatientVitale = {
      immatriculation: res.s_nir.trim().replace(/\s+/g, ''),
      dateNaissance: res.s_moonbirthday
        ?? (res.s_birthday ? moment(res.s_birthday, 'DD/MM/YYYY', true).format('YYYYMMDD') : undefined),
      rangGemellaire: res.i_birthRank.toString(),
    };

    try {
      const patientVitale = await this._patientService.patientsSearchFilters(filtreSearchPatient, this.filtre);
      let patientToOpen: ResultatPatient | undefined;

      if (patientVitale?.objects?.length > 0) {
        // on prend le premier (même si plusieurs) comme avant
        // TODO A CORRIGER POUR CHOIX SI PLUSIEUR
        patientToOpen = patientVitale.objects[0];
      } else {
        const patientVitaleFSE = await this._patientService.getPatientVitale(PatientVitale);

        if (patientVitaleFSE?.patientId) {
          // objet minimal juste pour ouvrir la fiche
          patientToOpen = { id: patientVitaleFSE.patientId } as ResultatPatient;
        }
      }

      if (patientToOpen) {
        const loadingModal = this._modalService.openLoading(this._view);
        this.openFichePatient(patientToOpen);
        this._modalService.close(loadingModal);
      } else {
        const confirm = this._modalService.openModalMultipleChoice(this._view, 'Attention', 'Ce patient n\'existe pas dans votre patientelle.', 'Voulez-vous :', [{ label: 'Créer', value: 'create', backgroundColor: 'var(--primary)' }, { label: 'Rechercher à partir du nom', value: 'search', backgroundColor: 'var(--primary)' }, { label: 'Annuler', value: 'quit', backgroundColor: 'var(--darkest-primary)' }]);
        const updateSub = confirm.instance.closeEmitter.subscribe(async (value: string | null) => {
          if (value) {
            switch (value) {
              case 'create':
                let sexe = 1;

                if (res.i_quality === 0 && res.s_nir && res.s_nir.charAt(0) === '1') {
                  // Dans le cas d'un NIR commençant par 1, le sexe est masculin
                  sexe = 2;
                } else if (res.i_quality === 0 && res.s_nir && res.s_nir.charAt(0) === '2') {
                  // Dans le cas d'un NIR commençant par 2, le sexe est féminin
                  sexe = 3;
                }

                let codeLieuNaissance: string | undefined = undefined;
                let patientIns: string | undefined = undefined;
                let patientInsKey: string | undefined = undefined;
                if (res.s_nir && res.s_nir !== "") {
                  const clnTmp = res.s_nir.substring(5, 10);
                  if (clnTmp && clnTmp.length === 5) {
                    codeLieuNaissance = clnTmp;
                  }

                  patientIns = res.s_nir.split(' ')[0];
                  patientInsKey = res.s_nir.split(' ')[1];
                }

                const patientInfos: InfosPatientCarteVitale & { sexe?: number; insc?: string; cpNaissance?: string; insKey?: string }= {
                  nom: res.s_name,
                  prenom: this._strUtilsSrv.uppercaseFirstCharString(res.s_given),
                  nomNaissance: res.s_birthname && res.s_birthname !== "" ? res.s_birthname : res.s_name,
                  birthday: res.s_birthday,
                  ins: patientIns,
                  sexe: sexe,
                  insc: res.s_insC ? res.s_insC : undefined,
                  cpNaissance: codeLieuNaissance,
                  insKey: patientInsKey,
                };
                this.addPatient(patientInfos);
                break;
              case 'search':
                this.searchForm.controls.nom.patchValue(res.s_name);
                this.searchForm.controls.prenom.patchValue(this._strUtilsSrv.uppercaseFirstCharString(res.s_given));
                break;
              case 'quit':
                confirm.destroy();
                break;
            }
          }
          updateSub.unsubscribe();
        });
      }
    } catch (e) {
      this._modalService.openAlert(this._view, 'Erreur', 'Impossible d\'afficher le(s) patient(s).');
      throw e;
    }
  }

  private _openModalPatientCarteVitale(infos: any[]) {
    const modal = this._modalService.openModalSelectList(this._view, 'Patient(s) carte vitale', this.patientVitaleColumnTable, infos, 'Veuillez sélectionner un patient.');
    modal.instance.validButtonLabel = 'Sélectionner';
    const sub = modal.instance.closeEmitter.subscribe(async (res: Patients) => {
      try {
        if (res && res.id != null) {
          const load = this._modalService.openLoading(this._view);
          const statusNochange = await this._cpxHandleSrv.checkVitaleStatus(this._view);
          let patientCardOk:Patients;
          if (statusNochange?.i_cardStatus == 6) {
            patientCardOk = res as Patients;
          } else {
            const listPatientsCarte = await this._cpxHandleSrv.lectureVitale(this._view);
            const infosPatientCarte = this._mapInfosPatientCarteVitale(listPatientsCarte) as Array<Patients>;
            patientCardOk = infosPatientCarte.find(p => p.id === res.id && p.s_certifiedNir === res.s_certifiedNir);
          }
          if (!patientCardOk) {
            load.destroy();
            this._modalService.openAlert(this._view, 'Mauvaise carte Vitale', 'La carte Vitale utilisée pour sélectionner un patient n\'est pas la même que la carte actuellement présente dans le lecteur.');
          } else {
            load.destroy();
            await this._getInsFromVitale(res);
          }
        }
      } finally {
        modal.destroy();
        sub.unsubscribe();
      }
    });
  }

  private parseBirthday(raw: string): { isLunar: boolean; yyyymmdd?: string } {
    if (!raw) {
      return { isLunar: false };
    }

    const digits = raw.replace(/\D/g, '');

    let day: string;
    let month: string;
    let year: string;

    if (digits.length === 8) {
      // DDMMYYYY
      day = digits.substring(0, 2);
      month = digits.substring(2, 4);
      year = digits.substring(4, 8);
    }

    else if (digits.length === 6) {
      // YYMMDD
      const yy = digits.substring(0, 2);
      month = digits.substring(2, 4);
      day = digits.substring(4, 6);

      const yyNum = parseInt(yy, 10);
      year = (yyNum <= 29 ? '20' : '19') + yy;
    }

    else {
      return { isLunar: false };
    }

    const dayNum = parseInt(day, 10);
    const monthNum = parseInt(month, 10);

    const isLunar = dayNum > 31 || monthNum > 12;

    return {
      isLunar,
      yyyymmdd: `${year}${month}${day}`
    };
  }
}
